module.exports = "/img/_/_/_/assets/images/icon//melee.png?5d225dea8146ff441bc2a35f66028435";